import React from 'react';
import { v4 as uuidv4 } from 'uuid';

const WidgetCustomer = (props) => {
  const preText = props.state.prevMessage;
  const param = props.payload.param;
  const _prev = () => {
    props.actionProvider._categoryPrev(preText);
  };
  const _goHome = () => {
    props.actionProvider._home(-1);
  };
  const _my = () => {
    window.open('https://shop.aniplustv.com/mypage');
  };
  const _qna = () => {
    window.open('https://shop.aniplustv.com/mypage/qna');
    // const sessionKey = uuidv4();
    // props.actionProvider._selectQna('1 : 1 문의하기', sessionKey);
  };
  return (
    <>
      {param === 'bad' ? (
        <div className="prev-add-content">
          <div className="content-add">
            <p>
              콜라보 카페에서 구매하신 상품에 불량이 있으신 경우 상품을 구매하신
              매장으로의 문의를 부탁드립니다.
            </p>
            <table className="contact-table">
              <thead>
                <tr>
                  <th>매장</th>
                  <th>전화번호</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>서울 합정점</td>
                  <td>070-7162-3000</td>
                </tr>
                <tr>
                  <td>대전 중앙로점</td>
                  <td>070-7162-7046</td>
                </tr>
                <tr>
                  <td>광주 충장로점</td>
                  <td>070-7162-7047</td>
                </tr>
                <tr>
                  <td>부산 서면점</td>
                  <td>070-7162-7048</td>
                </tr>
              </tbody>
            </table>

            <p>
              매장으로의 문의가 불가하신 경우, 성함/전화번호/구매 상품/불량의
              확인이 가능한 자료를 첨부하시어 고객센터
              이메일(webmaster@aniplustv.com)로 발송해주시길 바랍니다.
            </p>
            <p>
              온라인에서 구매한 상품이라면 위의 사유에 해당하시는 경우 “온라인샵
              1:1 문의”를 통해 번거로우시겠으나 사진을 함께 첨부하여 문의를
              주시길 바랍니다. 불량 사항으로 인한 교환, 환불 등의 상담을
              희망하시는 경우 “온라인샵 1:1 문의”를 이용해주시길 바랍니다.
            </p>

            <div className="common-info">
              <p>품목별 공통 안내 사항은 아래와 같습니다.</p>

              <p>[대표 품목별 교환 사유]</p>
              <ul className="reason-list">
                <li>
                  아크릴 제품: 보호 필름을 제거하신 후에도 불량 사항이 있으신
                  경우
                </li>
                <li>
                  피규어: 부품 누락, 심각한 도색 불량, 상품 부러짐 혹은 훼손
                </li>
                <li>
                  지류: 5mm 이상의 인쇄 불량, 눈에 띄는 접힘 및 기스, 눈에 띄는
                  접힘
                </li>
              </ul>

              <p>
                위의 사유에 해당하시는 경우 “온라인샵 1:1 문의”를 통해
                번거로우시겠으나 사진을 함께 첨부하여 문의를 주시길 바랍니다.
              </p>
              <p>
                미세한 기스, 눌림, 벗겨짐 등의 하자는 교환 사유에 해당하지
                않습니다.
              </p>
            </div>
          </div>
        </div>
      ) : param === 'missing' ? (
        <div className="prev-add-content">
          <div className="content-add">
            <p>
              콜라보 카페에서 구매하신 상품에 누락이 있으신 경우 상품을 구매하신
              매장으로의 문의를 부탁드립니다.
            </p>
            <table className="contact-table">
              <thead>
                <tr>
                  <th>매장</th>
                  <th>전화번호</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>서울 합정점</td>
                  <td>070-7162-3000</td>
                </tr>
                <tr>
                  <td>대전 중앙로점</td>
                  <td>070-7162-7046</td>
                </tr>
                <tr>
                  <td>광주 충장로점</td>
                  <td>070-7162-7047</td>
                </tr>
                <tr>
                  <td>부산 서면점</td>
                  <td>070-7162-7048</td>
                </tr>
              </tbody>
            </table>

            <p>
              매장으로의 문의가 불가하신 경우, 성함/전화번호/구매 상품/불량의
              확인이 가능한 자료를 첨부하시어 고객센터
              이메일(webmaster@aniplustv.com)로 발송해주시길 바랍니다.
            </p>
            <p>
              온라인에서 배송 상품 누락의 경우, 담당 부서에서 확인이 필요합니다.
            </p>
            <p>
              번거로우시겠지만 애니플러스 “온라인샵 1:1 문의” 혹은 고객센터
              이메일(webmaster@aniplustv.com)로 다음 필요 서류들을 보내주시면
              누락 사항 확인 후 배송 및 환불 처리를 도와드리겠습니다.
            </p>

            <div className="common-info">
              <p>[필요 서류]</p>
              <ul className="reason-list">
                <li>고객님의 성함과 애니플러스 아이디</li>
                <li>
                  상품의 누락 확인이 가능한 자료
                  <br />
                  (개봉 당시 혹은 수령하신 전체 상품의 사진 또는 영상)
                </li>
              </ul>

              <p>
                상품 누락으로 인해 불편을 끼쳐드린 점 다시 한 번 사과드리며
                보내주신 자료를 검토한 후에 빠르게 회신드리겠습니다.
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div></div>
      )}

      <div className="prev-chat-container">
        <div className="prev-contaner">
          <div className="prev" onClick={_qna}>
            <img src="/img/chatbot/icon_qna.png" />
            1:1문의 남기기
          </div>
        </div>
      </div>
      <div className="prev-chat-container">
        <div className="prev-contaner">
          {preText === '' ||
          preText === undefined ||
          preText === null ? null : (
            <div onClick={_prev} className="prev">
              <img src="/img/chatbot/icon_prev.png" />
              이전 단계로 이동
            </div>
          )}

          <div onClick={_goHome} className="prev">
            <img src="/img/chatbot/icon_home.png" />
            처음으로
          </div>
        </div>
      </div>
    </>
  );
};

export default WidgetCustomer;
